import React, { FunctionComponent, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { iPackage } from "../../../definitions/Package"
import { post } from "../../../store/data/actions"
import PackagesHeader from "../Header"
import Overview from "../inspector/Overview"

const CreatePackage: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({
    shouldUnregister: false,
    defaultValues: { isCustom: true },
  })

  const onSubmit = (data: iPackage) => {
    setLoading(true)
    post<iPackage>({ link: "/v1/packages", data }).then((packageObject) => {
      setLoading(false)
      history.push("/packages/" + packageObject._id)
      store.addNotification({
        title: "Success!",
        message: "Package successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <PackagesHeader title={"Create a new package"} />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iPackage)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <Overview />
          </Route>
          {isLoading}
        </form>
      </div>
    </FormProvider>
  )
}

export default CreatePackage
